import React from "react"

import { OrdersSetAsViewedButton } from "components"
import classes from "./NcoFooter.module.scss"

const NcoFooter = (props) => {
  const { setOrders } = props

  return (
    <div className={classes["footer"]}>
      <OrdersSetAsViewedButton
        orderStatus="notConfirmed"
        setOrders={setOrders}
      />
    </div>
  )
}

export default NcoFooter